<app-dialog-base class="modalcreateuser" [Title]='"Users"|translate' [dialogId]="dialogId" [width]="'870px'"
  [height]="'520px'" (onClose)="close()" (onSubmit)="submit()" [isSubmitDisabled]="isLoading" [isLoading]="isLoading">
  <div class="btn_tabs">
    <button (click)="openTab('userData')" [class.active]="openedTabName == 'userData'">{{"Account"|translate}}</button>
    <button (click)="openTab('userSettings')" [class.active]="openedTabName == 'userSettings'">{{"Access rights and
      roles"|translate}}</button>
    <button (click)="openTab('groupAccess')" [class.active]="openedTabName == 'groupAccess'">{{"Access
      rights"|translate}}</button>
    <button (click)="openTab('containerAccess')"
      [class.active]="openedTabName == 'containerAccess'">{{"Containers"|translate}}</button>
    <button (click)="openTab('interfaceSettings')"
      [class.active]="openedTabName == 'interfaceSettings'">{{"Interface"|translate}}</button>
  </div>
  <div class="horseparator"></div>
  <div id="userData" *ngIf="isSelected('userData')" class="tablewrap">
    <div class="table">
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Company'|translate}}</label>
          <select class="company-select" title="{{'Company'|translate}}" [(ngModel)]="model.CompanyId">
            <option *ngFor="let company of companies" value="{{company.Id}}"
              [selected]="model.CompanyId === company.Id">
              {{company.Name}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{"Account"|translate}}</label>
          <input placeholder="{{'Account'|translate}}" type="text" [(ngModel)]="model.Name" />
        </div>
        <!--        <div class="inputgroup" *ngIf="model.Id > 0">
          <label></label>
          <div class="userstat">
            <div>
              {{"Objects"|translate}}:
              <span>{{model.ObjectsCount}}</span>
            </div>
            <div>
              {{"Geozones"|translate}}:
              <span>{{model.GeozonesCount}}</span>
            </div>
          </div>
        </div>-->
        <div class="inputgroup">
          <label>{{'Phone №'|translate}}</label>
          <input placeholder="{{'Phone №'|translate}}" type="text" [(ngModel)]="model.PhoneNumber" />
        </div>
        <div class="inputgroup">
          <label>{{'Email'|translate}}</label>
          <input placeholder="{{'Email'|translate}}" type="text" [(ngModel)]="model.Email"
            [readonly]="!usersService.IsPermitted(AccessRights.EDITUSERS)" />
        </div>
      </div>
      <div class="blockheader">{{'Geolocation and language'|translate}}</div>
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Timezone'|translate}}</label>
          <select title="{{'Timezone'|translate}}" [(ngModel)]="model.TimeZone">
            <option *ngFor="let timezone of timezones" value="{{timezone.Name}}"
              [selected]="model.TimeZone === timezone.Name">
              {{timezone.DisplayName}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'Language'|translate}}</label>
          <select title="{{'Language'|translate}}" [(ngModel)]="model.Language">
            <option *ngFor="let language of languages" value="{{language.code}}"
              [selected]="model.Language.toLowerCase() == language.code">
              {{language.discription}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'Geocoding service'|translate}}</label>
          <select title="{{'Geocoding service'|translate}}" [(ngModel)]="model.Geocoder">
            <option *ngFor="let geocoder of geocoders" value="{{geocoder.Name}}"
              [selected]="model.Geocoder == geocoder.Name">
              {{geocoder.Name|translate}}
            </option>
          </select>
        </div>
        <div class="inputgroup" *ngIf="model.CreatedAt">
          <label>{{'Created at'|translate}}</label>
          <label>{{model.CreatedAt | date: 'dd.MM.yyyy'}}</label>
        </div>
        <div class="inputgroup">
          <label>{{'System of units'|translate}}</label>
          <select title="{{'System of units'|translate}}" (change)="onChangeUnits($event)">
            <option value="" [selected]="!model.HasFlag('MILES')">{{'Metric'|translate}}</option>
            <option value="MILES" [selected]="model.HasFlag('MILES')">{{'Imperial (foots/miles)'|translate}}</option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'Area units'|translate}}</label>
          <select title="{{'Area units'|translate}}" (change)="onChangeAreaUnits($event)">
            <option value="" [selected]="!model.HasFlag('HECTARES')">{{'km²'|translate}}</option>
            <option value="HECTARES" [selected]="model.HasFlag('HECTARES')">{{'Hectares (ha)'|translate}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div id="userSettings" *ngIf="isSelected('userSettings')" class="tablewrap">
    <div class="table">
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Blocked'|translate}}</label>
          <input type="checkbox" [(ngModel)]="model.IsDisabled" />
        </div>
        <div class="inputgroup">
          <label>{{'Role'|translate}}</label>
          <select title="{{'Role'|translate}}" (change)="onChangeMask($event)">
            <option *ngFor="let role of roles" value="{{role.Value}}" [selected]="isRoleSelected(role)">
              {{role.Name | translate}}
            </option>
          </select>
        </div>
        <div class="blockheader">{{'History limits'|translate}}</div>
        <div class="datablock">
          <div class="inputgroup">
            <label>{{'From'|translate}}</label>
            <calendar [name]="'HistoryFromLimit' + dialogId" [(date)]="model.FromLimit" [clear]="canEditHistoryLimits"
              [disabled]="!canEditHistoryLimits" [format]="'%0D.%0M.%0Y %0h:%0m:%0s'"></calendar>
          </div>
          <div class="inputgroup">
            <label>{{'To'|translate}}</label>
            <calendar [name]="'HistoryTillLimit' + dialogId" [(date)]="model.TillLimit" [clear]="canEditHistoryLimits"
              [disabled]="!canEditHistoryLimits" [format]="'%0D.%0M.%0Y %0h:%0m:%0s'"></calendar>
          </div>
        </div>
        <!-- <div class="inputgroup" *ngIf="isCheckboxAvailable()">
          <label>{{'Objects edit'|translate}}</label>
          <input type="checkbox" [checked]="isChecked(AccessRights.EDIT_TRACKERS)" (change)="onToggleMask(AccessRights.EDIT_TRACKERS,$event)" />
        </div>
        <div class="inputgroup" *ngIf="isCheckboxAvailable() && isChecked(AccessRights.EDIT_TRACKERS)">
          <label>{{'Add/remove trackers'|translate}}</label>
          <input type="checkbox" [checked]="isChecked(AccessRights.EDIT_TRACKERS_IMEI)" (change)="onToggleMask(AccessRights.EDIT_TRACKERS_IMEI,$event)" />
        </div>
        -->
      </div>
      <ng-container *ngIf="model.Id > 0">
        <div class="blockheader">{{'Change password'|translate}}</div>
        <div class="datablock">
          <div class="inputgroup">
            <label>{{'New password'|translate}}</label>
            <input placeholder="{{'New password'|translate}}" type="password" [(ngModel)]="model.Password" />
          </div>
          <div class="inputgroup">
            <label>{{'Password confirmation'|translate}}</label>
            <input placeholder="{{'Password confirmation'|translate}}" type="password"
              [(ngModel)]="model.PasswordConfirmation" />
          </div>
          <div class="inputgroup">
            <label class="addinfo">&nbsp;</label>
            <button class="btn_blue" (click)="changePassword()">{{'Change password'|translate }}</button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="model.Id == 0 || model.Id == undefined">
        <div class="blockheader">{{'Password'|translate}}</div>
        <div class="datablock">
          <div class="inputgroup">
            <label>{{'New password'|translate}}</label>
            <input placeholder="{{'New password'|translate}}" type="password" [(ngModel)]="model.Password" />
          </div>
          <div class="inputgroup">
            <label>{{'Password confirmation'|translate}}</label>
            <input placeholder="{{'Password confirmation'|translate}}" type="password"
              [(ngModel)]="model.PasswordConfirmation" />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div id="interfaceSettings" *ngIf="isSelected('interfaceSettings')" class="tablewrap">
    <div class="table">
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Start page'|translate}}</label>
          <select title="{{'Start page'|translate}}" (change)="onChangeStartPage($event)">
            <option value="" [selected]="!model.HasFlag('START_')"
              *ngIf="InterfaceIsPermitted(InterfacePermissions.TRACKING)">
              {{'Tracking' | translate}}
            </option>

            <option value="START_ANALYTICS" [selected]="model.HasFlag('START_ANALYTICS')"
              *ngIf="InterfaceIsPermitted(InterfacePermissions.ANALYTICS)">
              {{'Analytics' | translate}}
            </option>

            <option value="START_REPORTS" [selected]="model.HasFlag('START_REPORTS')"
              *ngIf="InterfaceIsPermitted(InterfacePermissions.REPORTS)">
              {{'Reports' | translate}}
            </option>

            <option value="START_DRIVERS" [selected]="model.HasFlag('START_DRIVERS')"
              *ngIf="InterfaceIsPermitted(InterfacePermissions.DRIVERS)">
              {{'Drivers' | translate}}
            </option>

            <option value="START_SERVICE" [selected]="model.HasFlag('START_SERVICE')"
              *ngIf="InterfaceIsPermitted(InterfacePermissions.SERVICE)">
              {{'Service' | translate}}
            </option>

            <option value="START_DISPATCHER" [selected]="model.HasFlag('START_DISPATCHER')"
              *ngIf="InterfaceIsPermitted(InterfacePermissions.DISPATCHER)">
              {{'Dispatcher' | translate}}
            </option>

            <option value="START_DATAINFO" [selected]="model.HasFlag('START_DATAINFO')"
              *ngIf="InterfaceIsPermitted(InterfacePermissions.DATAINFO)">
              {{'Raw data' | translate}}
            </option>
          </select>
        </div>

        <div class="blockheader">{{'Available pages'|translate}}</div>
        <div class="table">
          <table>
            <tr
              *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.ANALYTICS) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Analytics'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.ANALYTICS)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.ANALYTICS, $event)" />
              </td>
            </tr>
            <tr
              *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.HISTORY) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'History'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.HISTORY)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.HISTORY, $event)" />
              </td>
            </tr>
            <tr
              *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.REPORTS) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Reports'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.REPORTS)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.REPORTS, $event)" />
              </td>
            </tr>
            <tr
              *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DRIVERS) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Drivers'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.DRIVERS)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.DRIVERS, $event)" />
              </td>
            </tr>
            <tr
              *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.SERVICE) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Service'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.SERVICE)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.SERVICE, $event)" />
              </td>
            </tr>
            <tr
              *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DISPATCHER) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Dispatcher'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.DISPATCHER)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.DISPATCHER, $event)" />
              </td>
            </tr>
            <tr
              *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DATAINFO) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Raw data'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.DATAINFO)"
                  (change)="onToggleMask(AccessRights.VIEW_TRACKER_PACKET, $event)" />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div id="groupAccess" *ngIf="isSelected('groupAccess')" class="tablewrap">
    <div class="group-access-body">
      <div class="group-list-panel">
        <div class="filter-row">
          <input class="searchinput" type="text" placeholder="{{'Search'|translate}}" [(ngModel)]="groupAccessTerm" />
          <button class="btnadd" style="padding-left: 20px;" type="button" (click)="openGroupPicker()"
            [disabled]="!canOpenGroupPicker()"></button>
        </div>
        <div class="group-list">
          <div class="group-item" *ngFor="let group of filteredAccessGroups"
            [class.active]="selectedAccessGroup?.Id == group.Id" (click)="selectAccessGroup(group)">
            <div class="group-text">
              <div class="group-name" [title]="group.Name">{{group.Name}}</div>
              <div class="group-company" *ngIf="group.CompanyId" [title]="getGroupCompanyName(group.CompanyId)">
                {{getGroupCompanyName(group.CompanyId)}}
              </div>
            </div>
            <button class="btn_img btn_trush" type="button" [disabled]="!canRemoveGroupFromUser(group)"
              (click)="removeGroupFromUser(group, $event)"></button>
          </div>
        </div>
        <div class="empty-users" *ngIf="filteredAccessGroups.length == 0">
          {{'No groups'|translate}}
        </div>
      </div>

      <div class="rights-panel" *ngIf="selectedAccessGroup">
        <div class="rights-header">
          <div class="tableheader">{{'Access rights for'|translate}} {{model.Name}}</div>
        </div>
        <div class="rights-panel-body">
          <div class="presets-row">
            <span class="presets-title">{{'Presets of access rights'|translate}}</span>
            <button class="btn_preset" *ngFor="let preset of aclPresets"
              [class.active]="activeGroupPresetMask === preset.mask" (click)="applyGroupPreset(preset.mask)"
              [disabled]="selectedAccessGroup?.CanSelect === false || !canEditGroupRights">
              {{preset.label | translate}}
            </button>
          </div>
          <div class="acl-groups">
            <div class="acl-group" *ngFor="let group of aclGroups">
              <div class="acl-group-title">{{group.title | translate}}</div>
              <div class="acl-grid">
                <label class="acl-item" *ngFor="let acl of group.items">
                  <input type="checkbox"
                    [disabled]="selectedAccessGroup?.CanSelect === false || !canEditAclForSelectedGroup() || !isAclAllowedForGroup(acl.value)"
                    [checked]="isGroupAclSet(acl.value)" (change)="onGroupAclChange(acl.value, $event)" />
                  <span>{{acl.label | translate}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="containerAccess" *ngIf="isSelected('containerAccess')" class="tablewrap">
    <div class="group-access-body">
      <div class="group-list-panel">
        <div class="filter-row">
          <input class="searchinput" type="text" placeholder="{{'Search'|translate}}"
            [(ngModel)]="containerAccessTerm" />
          <button class="btnadd" style="padding-left: 20px;" type="button" (click)="openContainerPicker()"
            [disabled]="!canOpenContainerPicker()"></button>
        </div>
        <div class="group-list">
          <div class="group-item" *ngFor="let container of filteredAccessContainers"
            [class.active]="selectedAccessContainer?.Id == container.Id" (click)="selectAccessContainer(container)">
            <div class="group-text">
              <div class="group-name" [title]="container.Name">{{container.Name}}</div>
              <div class="group-company" *ngIf="container.CompanyId"
                [title]="getContainerCompanyName(container.CompanyId)">
                {{getContainerCompanyName(container.CompanyId)}}
              </div>
            </div>
            <button class="btn_img btn_trush" type="button" [disabled]="!canRemoveContainerFromUser(container)"
              (click)="removeContainerFromUser(container, $event)"></button>
          </div>
        </div>
        <div class="empty-users" *ngIf="filteredAccessContainers.length == 0">
          {{'No containers'|translate}}
        </div>
      </div>

      <div class="rights-panel" *ngIf="selectedAccessContainer">
        <div class="rights-header">
          <div class="tableheader">{{'Access rights for'|translate}} {{model.Name}}</div>
        </div>
        <div class="rights-panel-body">
          <div class="presets-row">
            <span class="presets-title">{{'Presets of access rights'|translate}}</span>
            <button class="btn_preset" *ngFor="let preset of containerAclPresets"
              [class.active]="activeContainerPresetMask === preset.mask" (click)="applyContainerPreset(preset.mask)"
              [disabled]="selectedAccessContainer?.CanSelect === false || !canEditContainerRights">
              {{preset.label | translate}}
            </button>
          </div>
          <div class="acl-groups">
            <div class="acl-group" *ngFor="let group of containerAclGroups">
              <div class="acl-group-title">{{group.title | translate}}</div>
              <div class="acl-grid">
                <label class="acl-item" *ngFor="let acl of group.items">
                  <input type="checkbox"
                    [disabled]="selectedAccessContainer?.CanSelect === false || !canEditAclForSelectedContainer() || !isAclAllowedForContainer(acl.value)"
                    [checked]="isContainerAclSet(acl.value)" (change)="onContainerAclChange(acl.value, $event)" />
                  <span>{{acl.label | translate}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-dialog-base>
<template #groupsListDialog></template>
